import Vue from 'vue'
import Router, {Route} from 'vue-router'

import root from './routes/root.vue'
import PageNotFound from './routes/pagenotfound.vue'
import noAccess from './routes/noAccess.vue'
import {frontendClient} from "./lib/client";

Vue.use(Router)


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./routes/root.vue'),
    },
    //WORKER ROUTES
    {
      path: '/home/',
      name: 'worker-home',
      component: () => import('./routes/walker/home.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    {
      path: '/jobs/',
      redirect: '/jobs/current'
    },
    {
      path: '/jobs/:title?',
      name: 'worker-jobs',
      component: () => import('./routes/walker/jobs.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    {
      path: '/calendar/:scope?/:date?',
      name: 'worker-calendar',
      component: () => import('./routes/walker/calendar.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    {
      path: '/alerts/:alertID?',
      name: 'worker-alerts',
      component: () => import('./routes/walker/alerts.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    {
      path: '/graphs/',
      name: 'worker-graphs',
      component: () => import('./routes/walker/graphs.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    {
      path: '/chat/:connectedToID?',
      name: 'worker-chat',
      component: () => import('./routes/walker/chat.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    {
      path: '/updates/',
      name: 'worker-updates',
      component: () => import('./routes/walker/updates.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("staff",next)
      }
    },
    // ADMIN ROUTES
    {
      path: '/a/',
      name: 'admin-home',
      component: () => import('./routes/admin/home.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/calendar',
      name: 'admin-calendar',
      component: () => import('./routes/admin/calendar.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/jobs/:title?',
      name: 'admin-jobs',
      component: () => import('./routes/admin/jobs.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/chat/:connectedToID?',
      name: 'admin-chat',
      component: () => import('./routes/admin/chat.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/updates',
      name: 'admin-updates',
      component: () => import('./routes/admin/updates.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/staff/:userID?',
      name: 'admin-staff',
      component: () => import('./routes/admin/staff.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/clients/:name?',
      name: 'admin-clients',
      component: () => import('./routes/admin/clients.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },
    {
      path: '/a/alerts',
      name: 'admin-alerts',
      component: () => import('./routes/admin/alerts.vue'),
      beforeEnter: (to,from,next) => {
        getAuth("admin",next)
      }
    },

    // COMMON ROUTES

    {
      path: '/job/:jobID',
      name: 'jobView',
      component: () => import('./routes/jobView.vue'),
      beforeEnter: (to,from,next) => {
        canSeeJob(to,next)
      }
    },

    {
      path: 'accessdenied',
      name: 'accessDenied',
      component: noAccess
    },
    // 404 route
    // this is always at the bottom because it's the lowest priority
    {
      path: '*',
      name: '404 Not Found',
      component: PageNotFound
    },
  ]
})

async function getAuth(rank,next){
  let promise = new Promise((resolve,reject) => {
    let interval = setInterval(() => {
      if(frontendClient.userData.rank){
        clearInterval(interval);
        interval = null;
        resolve();
      }
    },100)
  }).then(() =>{
    if(frontendClient.userData.rank == rank){
      next()
    }else{
      next({ name: 'accessDenied' })
    }
  }).catch()
}

async function canSeeJob(to,next){
  let jobID = to.params.jobID;
  next();
  // new Promise((resolve,reject) => {
    
  // }).then(() =>{

  // }).catch()
}